import { render } from "./UploadTrip.vue?vue&type=template&id=c4c048e0"
import script from "./UploadTrip.vue?vue&type=script&lang=js"
export * from "./UploadTrip.vue?vue&type=script&lang=js"
script.render = render

export default script